import { styled } from '@mui/material/styles'
import { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'
import { Tooltip } from '@mui/material'
import theme from 'theme'

export const InstanceTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `${theme.spacing.xSmall}px ${theme.spacing.small}px`,
    borderRadius: theme.attributes.borderRadius.secondary,
    border: `1px solid ${theme.colors.controlBorder}`,
    background: theme.colors.surfaceItemBackgroundLow,
    boxShadow: theme.attributes.boxShadow.selectFieldPaper,
    margin: 0,
    height: '100%',

    "html[data-theme='light'] &": {
      background: theme.colors.tooltipBg,
      borderColor: theme.colors.strokePrimary
    }
  },

  '.tooltip-wrapper': {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: '100%',

    '.arrow-up': {
      position: 'absolute',
      top: '-20px',
      left: 'calc(50% - 8px)'
    }
  },

  '.tooltip-text': {
    color: theme.colors.white,
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.large,
    fontStyle: 'normal',
    fontWeight: theme.typography.fontWeight.normal,
    lineHeight: 'normal',
    // whiteSpace: 'nowrap',
    wordBreak: 'break-all',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',

    "html[data-theme='light'] &": {
      color: theme.colors.menuItemText
    }
  }
})
